export default __webpack_public_path__ + "static/articles-hepato-jluchka-2b5b0f65196b24f576ffed0d24880904.jpg";